import {
    Box,
    Flex,
    Heading,
    Stack,
} from '@chakra-ui/react'

import { Container } from '../Container'
import { Headline } from '../Headline'
import Image from 'next/image'
import { InView } from 'react-intersection-observer'
import { motion } from 'framer-motion'
import { useState } from 'react'

function ProductFeature(props) {
    const { color, index, children, description, isActive, ...rest } = props
    return (
        <Box as='button' cursor='pointer' type='button' textAlign='start' {...rest}>
            <Heading
                as="h3"
                size="xs"
                color={isActive ? 'fg.default' : 'gray.500'}
                className='group'
                _hover={{ color: isActive ? undefined : 'gray.600' }}
            >
                <Box
                    as='span'
                    color={isActive ? color : 'gray.500'}
                    _groupHover={{ color: isActive ? undefined : 'gray.600' }}
                >
                </Box>
                <span>{children}</span>
            </Heading>
            <motion.span
                animate={{
                    display: 'block',
                    height: isActive ? 'auto' : '0px',
                    overflow: 'hidden',
                }}
            >
                <Box
                    as='span'
                    maxWidth='25rem'
                    fontSize='md'
                    fontWeight='normal'
                    marginTop={6}
                    display='block'
                    color="fg.default"
                >
                    {description}
                </Box>
            </motion.span>
        </Box>
    )
}

function ProductImage(props) {
    const { isActive, image, video, title, color, ...rest } = props
    return (
        <>
            {image && (
                <Image
                    hidden={!isActive}
                    width={0}
                    height={0}
                    sizes="100vw"
                    src={image}
                    alt={title}
                    loading="lazy"
                    preload="true"
                    // priority="true"
                    style={{ objectFit: 'contain', width: '100%', height: 'auto' }}
                    {...rest}
                />
            )}
            {video && (
                <Box
                    as='video'
                    height={400}
                    width={400}
                    autoPlay
                    muted
                    loop
                    controls={false}
                    src={video}
                    type="video/mp4"
                />
            )}
        </>
    )
}


function ProductFeatures({ data = [] }) {

    const [activeIndex, setActiveIndex] = useState(0)

    return (
        <Flex
            justify='space-between'
            direction={{ base: 'column', lg: 'row' }}
        >
            <Stack spacing='10'>
                {/*** mobile ***/}
                {data?.map((feature, index) => (
                    <Stack
                        key={index}
                        spacing={{ base: 9, lg: 0 }}
                        paddingStart={8}
                        borderStartWidth='4px'
                        borderStartColor={
                            index === activeIndex ? feature.color : 'gray.200'
                        }
                    >
                        <ProductFeature
                            isActive={index === activeIndex}
                            color={feature.color}
                            index={index + 1}
                            description={feature.description}
                            onClick={() => setActiveIndex(index)}
                        >
                            {feature.label}
                        </ProductFeature>
                        <Box
                            display={{ base: index === activeIndex ? 'initial' : 'none', lg: 'none' }}
                            width={feature?.imgW ? `${feature?.imgW}px` : 'initial'}
                            height={feature?.imgH ? `${feature?.imgH}px` : 'initial'}
                            overflow={feature?.imgH ? "scroll" : "auto"}
                            m="auto"
                            boxShadow='md'
                            borderRadius="xl"
                        >
                            <ProductImage
                                isActive={index === activeIndex}
                                color={feature.color}
                                label={feature.label}
                                image={feature.imgSrc}
                                video={feature.video}
                            />
                        </Box>
                    </Stack>
                ))}
            </Stack>
                {/*** desktop ***/}
            <Box
                maxWidth='40rem'
                marginX='auto'
                display={{ base: 'none', lg: 'flex' }}
            >
                {data.map((feature, index) => (
                    <Box
                        key={index}
                        height={feature?.imgH ? `${feature?.imgH}px` : 'initial'}
                        overflow={feature?.imgH ? "scroll" : "auto"}
                        m="auto"
                        boxShadow='md'
                        borderRadius="md"
                    >
                        <ProductImage
                            isActive={index === activeIndex}
                            key={index}
                            color={feature.color}
                            title={feature.label}
                            image={feature.imgSrc}
                            video={feature.video}
                        />
                    </Box>
                ))}
            </Box>
        </Flex>
    )
}

export function VerticalHeroTabs(props = {}) {
    const { headline, data, ...rest } = props || {}
    return (
        <InView triggerOnce>
            {({ inView, ref, entry }) => (
                <Box ref={ref} /* opacity={inView ? 1 : 0} */ transition="500ms" as='section' {...rest}>
                    {/* inView && ( */
                        <Container>
                            <Stack spacing={{ base: 16, lg: 32 }}>
                                {headline?.heading && (
                                    <Headline
                                        heading={headline?.heading}
                                        subheading={headline?.subheading}
                                        textAlign="center"
                                        marginX='auto'
                                    />
                                )}
                                <ProductFeatures data={data} />
                            </Stack>
                        </Container>
                    /*) */}
                </Box>
            )}
        </InView>
    )
}
